import React from "react";
import "../../scss/info.scss";

export default function Info() {
  return (
    <div id="info">
      Please note that this project is still <b>WIP</b>. Thanks!
    </div>
  );
}
